export { default } from "./HomeGreeting";
